import React from 'react';
import { Link } from 'react-router-dom';
import Chapters from '../../data/header/Chapters.json';
const BrandList = Chapters

const ChaptersBrand = ({brandStyle}) => {
     return (
        <ul className={`brand-list ${brandStyle}`}>
            {BrandList.map((data, index) => (
                <li key={index}>
                    <Link to={data.link} ><img src={`${data.img}`} alt="Brand Image" /></Link>
                </li>
            ))}
        </ul>
    )
}

export default ChaptersBrand;
